import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { OfficeThemeProvider } from "@/office/OfficeThemeProvider";
import App from "@/App";
import { initOffice } from "@/office/integration";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root not found");

initOffice(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <OfficeThemeProvider>
        <App />
      </OfficeThemeProvider>
    </StrictMode>,
  );
});
